import { Component, OnInit, AfterViewInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { debounceTime } from 'rxjs';
import moment from 'moment';
import {
  IGetRelatorioVendasPorProdutoItem,
  IGetRelatorioVendasPorProdutoListResponse,
  IGetRelatorioVendasPorProdutoParams
} from 'src/app/services/ReportService/report.model';
import { ReportService } from 'src/app/services/ReportService/report.service';
import { AppExportBase64 } from 'src/app/services/ExportBase64/exportBase64.service';

@Component({
  selector: 'app-relatorio-vendas-por-produto',
  templateUrl: './relatorio-vendas-por-produto.component.html',
  styleUrls: ['./relatorio-vendas-por-produto.component.scss']
})
export class RelatorioVendasPorProdutoComponent implements OnInit, AfterViewInit {
  form = this.fb.group({
    DT_INIC: [null as string | null],
    DT_FIM: [null as string | null]
  });

  isLoading = false;
  tableData: Array<any> = [];
  quantidadeTotal = 0;
  valorTotalGeral = 0;

  tableColumns = [
    { header: 'Tipo de Serviço', key: 'tipoServico', type: 'text' },
    { header: 'Quantidade', key: 'quantidade', type: 'text' },
    { header: 'Valor Total', key: 'valorTotal', type: 'text' }
  ];

  constructor(
    private fb: FormBuilder,
    private reportService: ReportService,
    private appExportBase64: AppExportBase64
  ) {
    const fim = moment().endOf('day');
    const inicio = moment().subtract(3, 'months').startOf('month');
    this.form.patchValue({
      DT_INIC: inicio.format('YYYY-MM-DDTHH:mm'),
      DT_FIM: fim.format('YYYY-MM-DDTHH:mm')
    });
  }

  ngOnInit(): void {
    this.loadData();
  }

  ngAfterViewInit(): void {
    this.form.valueChanges.pipe(debounceTime(300)).subscribe(() => this.loadData());
  }

  private createPayload(): IGetRelatorioVendasPorProdutoParams {
    return {
      DT_INIC: this.form.controls.DT_INIC.value ?? undefined,
      DT_FIM: this.form.controls.DT_FIM.value ?? undefined
    };
  }

  loadData(): void {
    this.isLoading = true;

    this.reportService.GetRelatorioVendasPorProduto(this.createPayload()).subscribe({
      next: (response: IGetRelatorioVendasPorProdutoListResponse) => {
        this.tableData = (response.ITEMS ?? []).map((item: IGetRelatorioVendasPorProdutoItem) => ({
          tipoServico: item.TX_TIPO_SRVC ?? '---',
          quantidade: item.Quantidade?.toLocaleString('pt-BR') ?? '0',
          valorTotal: this.formatCurrency(item.ValorTotal ?? 0)
        }));
        this.quantidadeTotal = response.QuantidadeTotal ?? 0;
        this.valorTotalGeral = response.ValorTotalGeral ?? 0;
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }

  exportarExcel(): void {
    this.isLoading = true;

    this.reportService.GetReportVendasPorProdutoExcel(this.createPayload()).subscribe({
      next: response => {
        this.appExportBase64.downloadExcel(response.ReportBase64, 'Vendas por Produto.xlsx');
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }

  get valorTotalFormatado(): string {
    return this.formatCurrency(this.valorTotalGeral);
  }

  get quantidadeTotalFormatada(): string {
    return this.quantidadeTotal.toLocaleString('pt-BR');
  }

  private formatCurrency(value: number): string {
    return value.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }
}
